import { ChangeDetectorRef, Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { ActivatedRoute, Router } from '@angular/router';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import moment from 'moment';
import { Clipboard } from '@angular/cdk/clipboard';
import { Title } from '@angular/platform-browser';
import { Subject, takeUntil, finalize, catchError, of, Subscription } from 'rxjs';
import { SharedService } from 'src/app/shareModule/services/shared.service';

@Component({
  selector: 'app-poll',
  templateUrl: './poll.component.html',
  styleUrls: ['./poll.component.scss'],
})
export class PollComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  @ViewChild('pollDetailModal', { static: true })
  pollDetailModal: TemplateRef<any>;

  constructor(
    private router: Router,
    private local: LocalServiceService,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private clipboard: Clipboard,
    private route: ActivatedRoute,
    private title: Title,
    private cdr: ChangeDetectorRef,
    private sharedService: SharedService
  ) {
    this.title.setTitle(`Poll | KACHIING`);
  }

  private modalRef: any;
  isLogin: any = 0;
  isLoading: boolean = false;
  appUserId: any;
  categories: any = [];
  darkModeKey: string = 'darkMode';
  // Editor = ClassicEditor;
  EditorData: any = ``;
  EditorConfig = {
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        // 'insertTable',
        // 'imageUpload',
        // '|',
        'undo',
        'redo',
      ],
    },
  };
  poll: any = {
    name: '',
    startDate: '',
    endDate: '',
    polls: [],
  };
  pollDetail: any = {};
  polls: any = {
    isLoading: false,
    data: [],
    currentPage: 1,
  };
  //#9B58B5
  pollsColor: any = [
    'rgba(var(--secondary-r), var(--secondary-g), var(--secondary-b), 0.75)',
    '#3597DA',
    '#E67F22',
  ];
  newPolling: any = {};
  activeIndexPoll: number = 1;
  showFloatingMenu: boolean = false;

  private _userDetailSubscriber: Subscription = null

  ngOnInit() {
    try {
      this._userDetailSubscriber?.unsubscribe()
      this._userDetailSubscriber = this.local.getUserDetailsObserver().subscribe((user) => {
        if (user) {
          this.isLogin = 1
        }
        else {
          this.isLogin = 0
        }
        this.cdr.detectChanges()
      })
      this.isLoading = true;
      this.polls.isLoading = true;
      this.initPoll();
    } catch (error) {
      console.error('Error in ngOnInit:', error);
      this.isLoading = false;
      this.polls.isLoading = false;
      this.toastr.error('Failed to initialize poll component');
    }
  }

  ngOnDestroy(): void {
    // Clear all intervals
    this.polls?.data.forEach((row: any) => clearInterval(row.interval));
    this.destroy$.next();
    this.destroy$.complete();
    this._userDetailSubscriber?.unsubscribe()
  }

  isAdmin = () => this.local.getUser()?.role == 'admin';
  isModerator = () =>
    this.local.getUser()?.role == 'moderator' || this.isAdmin();
  isOwnMessage = (data: any) => {
    const user = this.local.getUser();
    if (!user) return false;

    if (this.isAdmin()) {
      return user.id == data.createdBy && data.isAdmin;
    } else {
      return user.id == data.createdBy && !data.isAdmin;
    }
  };

  startCountdown(item: any): void {
    try {
      if (item.interval) {
        clearInterval(item.interval);
      }

      item.interval = setInterval(() => {
        try {
          const now = new Date().getTime();
          const distance = new Date(item.endDate).getTime() - now;

          if (distance < 0) {
            clearInterval(item.interval);
            item.remainingTime = "Time's up!";
            return;
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          item.remainingTime =
            (days > 0 ? days + 'd ' : '') +
            (hours < 10 ? '0' + hours : hours) +
            ':' +
            (minutes < 10 ? '0' + minutes : minutes) +
            ':' +
            (seconds < 10 ? '0' + seconds : seconds);
        } catch (error) {
          console.error('Error in countdown interval:', error);
          clearInterval(item.interval);
        }
      }, 1000);
    } catch (error) {
      console.error('Error starting countdown:', error);
    }
  }

  handlePagination(value: number) {
    try {
      const length = this.polls?.data?.length - 1;
      let index = length + value;
      index = index < 0 ? length - 1 : index;
      index = index > length - 1 ? index - 1 : index;
      this.activeIndexPoll = index + 1;

      this.polls?.data?.map((row: any, i: number) => {
        row.isActive = false;
        if (i == index) row.isActive = true;
      });
    } catch (error) {
      console.error('Error in handlePagination:', error);
    }
  }

  scrollTo(id: string) {
    try {
      this.local.scrollTo(id);
    } catch (error) {
      console.error('Error scrolling to element:', error);
    }
  }

  formatDate(value: any) {
    try {
      return moment.unix(value).format('YYYY-MM-DD HH:mm:ss');
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }

  newPollingStore() {
    try {
      if (this.newPolling.option == '') {
        return this.toastr.error('please fill the option name');
      }

      this.newPolling.hasSubmit = true;
      this.auth.poll_option_store(this.newPolling)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.newPolling.hasSubmit = false;
          }),
          catchError((error) => {
            console.error('Error storing new polling option:', error);
            this.toastr.error('Failed to add polling option');
            return of(null);
          })
        )
        .subscribe((response) => {
          if (response) {
            this.initPoll();
            this.modalService.dismissAll();
          }
        });
    } catch (error) {
      console.error('Error in newPollingStore:', error);
      this.newPolling.hasSubmit = false;
    }
  }

  async handleShowOptionPoll(index: number) {
    try {
      await Promise.all(
        this.polls?.data?.map((row: any, i: number) => {
          if (index != i) row.showOption = false;
          // row.isEdit = false
        }) || []
      ).then(() => {
        if (this.polls.data[index]) {
          this.polls.data[index].showOption = !this.polls.data[index].showOption;
        }
      });
    } catch (error) {
      console.error('Error in handleShowOptionPoll:', error);
    }
  }

  initPoll() {
    this.polls.isLoading = true;
    this.auth.poll_fetch({}).subscribe((response: any) => {
      this.polls = response.body;
      this.polls.data.map((row: any, i: number) => {
        if (i == 0) row.isActive = true;
      });
      if (this.sharedService.isBrowser()) {
        this.initPollProgress();
        this.initPollLikes();
        this.showDetail('poll');
      }

      this.cdr.detectChanges()
    });
  }

  openPollModal(modal: any) {
    try {
      if (this.isLogin == 0) {
        return this.toastr.error('Please Login First !');
      }
      this.modalService.dismissAll();
      this.modalRef = this.modalService.open(modal, {
        size: 'sm',
        // backdrop: 'static',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'my-modal md',
      });
      this.poll = {
        isLoading: false,
        name: '',
        startDate: '',
        endDate: '',
        polls: [],
      };
    } catch (error) {
      console.error('Error opening poll modal:', error);
    }
  }

  addPollsChild() {
    try {
      this.poll.polls = [...this.poll.polls, {}];
    } catch (error) {
      console.error('Error adding poll child:', error);
    }
  }

  removePollsChild(i: number) {
    try {
      this.poll.polls = this.poll.polls.filter(
        (row: any, index: number) => index != i
      );
    } catch (error) {
      console.error('Error removing poll child:', error);
    }
  }

  storePoll() {
    try {
      const poll = this.poll;

      // Validation

      if (
        poll.name == '' ||
        poll.startDate == '' ||
        poll.endDate == '' ||
        poll.polls.length < 1
      ) {
        return this.toastr.error('Please fill the inputs !');
      }

      const startDate = moment(poll.startDate, 'YYYY-MM-DD');
      const endDate = moment(poll.endDate, 'YYYY-MM-DD');

      if (!endDate.isAfter(startDate)) {
        return this.toastr.error('Start Date should be Greater then End date!');
      }

      // Validation

      this.poll.uuid = this.local.generateUUID();

      this.polls.hasSubmit = true;
      this.auth.poll_store(poll)
        .pipe(
          takeUntil(this.destroy$),
          finalize(() => {
            this.polls.hasSubmit = false;
          }),
          catchError((error) => {
            console.error('Error storing poll:', error);
            this.toastr.error('failed to add poll');
            return of(null);
          })
        )
        .subscribe((response: any) => {
          if (response) {
            this.initPoll();
            this.modalService.dismissAll();
            this.toastr.success('successfully added poll');
          }
        });
    } catch (error) {
      console.error('Error in storePoll:', error);
      this.polls.hasSubmit = false;
    }
  }

  checkPoll(data: any, child: any, check = false) {
    try {
      if (this.isLogin == 0) {
        return this.toastr.error('Please Login First !');
      }
      const payload = {
        userId: this.appUserId,
        pollDetailId: child.id,
        isAdmin: this.isAdmin(),
      };

      if (this.hasCheckedPoll(child.poll_interactions)) {
        data.poll_interactions_count -= 1;
        child.poll_interactions = child.poll_interactions.filter(
          (row: any) =>
            row.userId != this.appUserId && row.isAdmin != this.isAdmin()
        );
      } else {
        data.poll_interactions_count += 1;
        child.poll_interactions = [...child.poll_interactions, payload];
      }

      this.pollProgress(data, child);
      this.initPollProgress(data.id, child.id);
      this.auth.poll_check(payload)
        .pipe(
          takeUntil(this.destroy$),
          catchError((error) => {
            console.error('Error checking poll:', error);
            return of(null);
          })
        )
        .subscribe();
    } catch (error) {
      console.error('Error in checkPoll:', error);
    }
  }

  initPollProgress(dataId: any = null, exceptId: any = null) {
    try {
      this.polls.data?.map((row: any) => {
        this.startCountdown(row);
        row.poll_interactions_count = 0;
        row.poll_details?.map((item: any) => {
          item.progress = 0;
          if (exceptId != null && dataId != null) {
            if (item.id != exceptId && dataId == row.id) {
              item.poll_interactions = item.poll_interactions.filter(
                (row: any) =>
                  row.userId != this.appUserId && row.isAdmin != this.isAdmin()
              );
            }
          }
          row.poll_interactions_count += item.poll_interactions?.length || 0;
        });
        row.poll_details?.map((item: any) => {
          this.pollProgress(row, item);
        });
        row.poll_details?.sort(
          (a: any, b: any) =>
            (b.poll_interactions?.length || 0) - (a.poll_interactions?.length || 0)
        );
      });
    } catch (error) {
      console.error('Error in initPollProgress:', error);
    }
  }

  pollProgress(data: any, child: any) {
    try {
      const result =
        ((child.poll_interactions?.length || 0) / (data.poll_interactions_count || 1)) * 100;
      child.progress = (result ? result : 0) + '%';
    } catch (error) {
      console.error('Error calculating poll progress:', error);
      child.progress = '0%';
    }
  }

  hasCheckedPoll(data: any) {
    try {
      return (
        (data || []).filter(
          (row: any) =>
            row.userId == this.appUserId && row.isAdmin == this.isAdmin()
        ).length > 0
      );
    } catch (error) {
      console.error('Error checking if poll is checked:', error);
      return false;
    }
  }

  likePoll(pollId: number, data: any) {
    try {
      if (this.isLogin == 0) {
        return this.toastr.error('Please Login First !');
      }
      const payload = {
        userId: this.appUserId,
        pollId: pollId,
        isAdmin: this.isAdmin(),
      };

      if (this.hasCheckedPoll(data.poll_likes))
        data.poll_likes = data.poll_likes.filter(
          (row: any) =>
            row.userId != this.appUserId && row.isAdmin != this.isAdmin()
        );
      else data.poll_likes = [...data.poll_likes, payload];

      this.initPollLikes();
      this.auth.poll_likes(payload)
        .pipe(
          takeUntil(this.destroy$),
          catchError((error) => {
            console.error('Error liking poll:', error);
            return of(null);
          })
        )
        .subscribe();
    } catch (error) {
      console.error('Error in likePoll:', error);
    }
  }

  openNewOptionModal(event: any, modal: any, item: any) {
    try {
      event.preventDefault();
      this.modalService.dismissAll();
      this.modalRef = this.modalService.open(modal, {
        size: 'sm',
        // backdrop: 'static',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'new_polling_option_modal',
      });
      this.newPolling = {
        title: item.name,
        id: item.id,
        option: '',
      };
    } catch (error) {
      console.error('Error opening new option modal:', error);
    }
  }

  initPollLikes() {
    try {
      this.polls.data?.sort(
        (a: any, b: any) => (b.poll_likes?.length || 0) - (a.poll_likes?.length || 0)
      );
    } catch (error) {
      console.error('Error sorting poll likes:', error);
    }
  }

  deletePoll(e: any, id: any) {
    try {
      e.preventDefault();
      const getConfirm = confirm('are you sure ?');

      if (getConfirm)
        this.auth.poll_delete(id)
          .pipe(
            takeUntil(this.destroy$),
            catchError((error) => {
              console.error('Error deleting poll:', error);
              this.toastr.error('Failed to delete poll');
              return of(null);
            })
          )
          .subscribe((response: any) => {
            if (response) {
              this.toastr.error('Poll has been deleted');
              this.initPoll();
            }
          });
    } catch (error) {
      console.error('Error in deletePoll:', error);
    }
  }

  showDetail(check: string) {
    try {
      this.route.queryParams
        .pipe(takeUntil(this.destroy$))
        .subscribe((params) => {
          try {
            const type = params.type;
            const uuid = params.uuid;
            if (type == 'poll' && check == type) {
              const data = this.polls.data?.filter((row: any) => row.uuid == uuid) || [];

              if (data.length > 0) {
                this.modalRef = this.modalService.open(this.pollDetailModal, {
                  size: 'xs',
                  // backdrop: 'static',
                });
                this.pollDetail = data[0];
              }
            }
          } catch (error) {
            console.error('Error processing query params:', error);
          }
        });
    } catch (error) {
      console.error('Error in showDetail:', error);
    }
  }

  copyLink(type: string, item: any) {
    try {
      let currentUrl = window.location.href.split('#')[0];
      currentUrl = currentUrl + '#/forum';
      this.clipboard.copy(`${currentUrl}?type=${type}&uuid=${item.uuid}`);
      this.toastr.success(`${type.toLocaleUpperCase()} Link Copied`);
    } catch (error) {
      console.error('Error copying link:', error);
      this.toastr.error('Failed to copy link');
    }
  }
}
